// Remove or comment out any Google Fonts imports if they exist
// import '@fontsource/poppins' or similar

// // Add import for our local fonts CSS
// import '../styles/fonts.css';

import React from 'react';
import { Container, Box, Typography, Button, Divider } from '@mui/material';
import { Link } from 'react-router-dom';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import MapIcon from '@mui/icons-material/Map';
import VerifiedIcon from '@mui/icons-material/Verified';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import CategoriesHomePage from '../components/CategoriesHomePage';
import banner from '../assets/HomePageBanner.webp';
import mobileBanner from '../assets/MobileBanner.webp';
import { useState,useEffect } from 'react';
import instance from '../utils/axiosConfig';
import alternateTheme from '../alternateTheme';
import { ThemeProvider } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import CategoryBar from '../components/CategoryBar';
import menuTheme from '../menuTheme';
import PopularProductsShowcase from '../components/PopularProductsShowcase';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';

const HomePage = () => {

  const [popularCategories, setPopularCategories] = useState([]); // Get first 6 categories
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingProducts, setIsLoadingProducts] = useState(true);
  const navigate = useNavigate();
  const theme = createTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [scrollbarWidth, setScrollbarWidth] = useState(0);
  const [categoriesLoading, setCategoriesLoading] = useState(true);

  const specialDeals = [
    { title: 'Deal 1', description: 'Special discount on selected items', link: '/deals/1' },
    { title: 'Deal 2', description: 'Buy one get one free', link: '/deals/2' },
    { title: 'Deal 3', description: '20% off on your first purchase', link: '/deals/3' },
  ];
  const trustedDistributors = [
    { name: 'Distributor 1', link: '/distributors/1' },
    { name: 'Distributor 2', link: '/distributors/2' },
    { name: 'Distributor 3', link: '/distributors/3' },
  ];

  const benefits = [
    { icon: <LocalShippingIcon sx={{ fontSize: 40 }} />, title: 'Envíos a Todo el País', description: 'Distribución nacional garantizada' },
    { icon: <VerifiedIcon sx={{ fontSize: 40 }} />, title: 'Vendedores Verificados', description: 'Calidad asegurada' },
    { icon: <SupportAgentIcon sx={{ fontSize: 40 }} />, title: 'Soporte 24/7', description: 'Estamos para ayudarte' },
  ];
  


 // Add this useEffect to fetch popular categories
 useEffect(() => {
    const fetchPopularCategories = async () => {
      setCategoriesLoading(true);
      try {
        const response = await instance.get('/api/products/popular-categories/search?limit=4');
        
        // Only update if we got valid data
        if (response.data && response.data.length > 0) {
          setPopularCategories(response.data.map(cat => cat.category));
        }
      } catch (error) {
        console.error('[NavBar] Error fetching popular categories:', error);
        // Keep default categories on error
      } finally {
        setCategoriesLoading(false);
      }
    };

    fetchPopularCategories();
  }, []);


  // Add this useEffect to handle initial load
  useEffect(() => {
    // Small timeout to ensure proper layout calculation
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 10);

    return () => clearTimeout(timer);
  }, []);

  // Add this useEffect to fetch featured products
  useEffect(() => {
    const fetchFeaturedProducts = async () => {
      try {
        const response = await instance.get('/api/products', {
          params: {
            featured: true,
            limit: 24, // Fetch 24 products to show in 6 slides of 4
            sortBy: 'views', // Sort by most viewed
            status: 'active'
          }
        });
        
        if (response.data && response.data.products) {
          setFeaturedProducts(response.data.products);
        }
      } catch (error) {
        console.error('Error fetching featured products:', error);
      } finally {
        setIsLoadingProducts(false);
      }
    };

    fetchFeaturedProducts();
  }, []);

  // Add this useEffect for scrollbar width detection
  useEffect(() => {
    const measureScrollbar = () => {
      // Create the measurement div
      const scrollDiv = document.createElement("div");
      scrollDiv.style.cssText = `
        width: 100px;
        height: 100px;
        overflow: scroll;
        position: absolute;
        top: -9999px;
      `;
      document.body.appendChild(scrollDiv);

      // Measure the difference
      const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

      // Remove the div
      document.body.removeChild(scrollDiv);

      // Add style to prevent horizontal scrolling
      document.documentElement.style.overflowX = 'hidden';
      document.body.style.overflowX = 'hidden';
      document.body.style.width = `calc(100vw - ${scrollbarWidth}px)`;

      return scrollbarWidth;
    };

    setScrollbarWidth(measureScrollbar());

    // Cleanup function to remove styles
    return () => {
      document.documentElement.style.overflowX = '';
      document.body.style.overflowX = '';
      document.body.style.width = '';
    };
  }, []); // Run once on mount

  // Don't render anything while loading
  if (isLoading) {
    return (
      <Box 
        sx={{ 
          width: '100vw', 
          height: '100vh', 
          backgroundColor: '#f4f4f4',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
      </Box>
    );
  }

  // Add this near the top of your HomePage component
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Liderdist",
    "description": "Plataforma mayorista B2B para distribuidores",
    "url": "https://liderdist.com",
    "sameAs": [
      "https://instagram.com/liderdist.arg",
      "https://x.com/liderdist_arg"
    ]
  };

  return !isMobile ? (
    <Box sx={{ backgroundColor: 'transparent', minHeight: '100vh',     width: `calc(100vw - ${scrollbarWidth}px)`,  }}>
      <Box sx={{
        backgroundImage: 'linear-gradient(to bottom,rgb(255, 191, 132) 25%, transparent)',
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}>
        <Box
          sx={{
            width:'68.8%',
            mx: `16.5%`,
            backgroundColor: '#fffbf0',
            p: 4,
            borderRadius: '1px',
            minHeight: '200px',
            display: 'flex',
            flexDirection: 'row',
            mt: '6vh',
          }}
        >
          <Box sx={{ flex: '0.58' }}>
          <Typography variant="h2" component="h2" sx={{ color: 'rgb(58, 54, 80)', fontWeight: '550', textAlign: 'left',fontSize: {md:'2.5rem'} }}>
            Bienvenido a Liderdist.com
          </Typography>
          <Typography variant="h2" component="h2" sx={{ color: 'rgb(70, 69, 78)',mb:1, textAlign: 'left',fontSize: {md:'1.2rem'} }}>
          La red B2B de proveedores y comercios.
          </Typography>
          <Typography variant="h6" component="h2" sx={{ color: 'rgb(66, 57, 78)',ml:0.5,fontWeight:500,textAlign: 'left',fontSize: {md:'1.25rem'}, lineHeight: 1.6 }}>
            Encontrá los mejores precios para tu empresa.<br/>
            Conectá directamente con los vendedores a través de sus datos de contacto.<br/>
            Generá relaciones comerciales y aumentá tus ventas.
          </Typography>
          <ThemeProvider theme={alternateTheme}>
          <Button 
            component={Link} 
            to="/signup"
            aria-label="Registrarse como distribuidor mayorista"
            size="large"
            variant='contained'
            sx={{ 
              backgroundColor: '#FF8C00',
              height: '50px',
              flex:0.6,
              width: '250px',
              mt: 2,
              fontSize: {md:'18px', lg:'20px'},
              borderRadius: '2px',
              boxShadow:'--Paper-shadow',
              fontWeight: '400',
              borderColor: 'rgba(255, 126, 5,0.7) !important',
              color: 'rgb(255, 255, 255)'}}
          >
                ¡Registrate sin cargo!
          </Button>
          </ThemeProvider>
          </Box>
          {/* Box to show some info to make the site look professional */}
          <Box
          sx={{
              flex:0.38,
            border: '1px solid rgba(0, 0, 0, 0.1)',
              width: '25%',
              borderRadius: '2px',
              backgroundColor: 'rgba(2, 2, 2, 0.82)',
              minHeight: '200px',
              padding: 3,
              display: 'flex',
              flexDirection: 'column',
              gap: 2
            }}
          >
            {/* Stats Row */}
            {/* <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Typography sx={{ color: '#FF8C00', fontSize: '2rem', fontWeight: 'bold' }}>
                +1000
              </Typography>
              <Typography sx={{ color: 'white', fontSize: '0.9rem' }}>
                Visitas diarias
              </Typography>
            </Box> */}

           
            {/* First Stat */}
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: 1,
              flex:0.33

            }}>
              <TrendingUpIcon sx={{ color: '#FF8C00', fontSize: '1.2rem' }} />
              <Typography sx={{ color: 'white', fontSize: '0.8rem' }}>
                Aumentá tu exposición
              </Typography>
            </Box>
            <Divider sx={{ backgroundColor: 'rgba(255,255,255,0.1)' }} />
            {/* Second Stat */}
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: 1,
              flex:0.33
            }}>
              <MapIcon sx={{ color: '#FF8C00', fontSize: '1.2rem' }} />
              <Typography sx={{ color: 'white', fontSize: '0.8rem' }}>
                Mapa de distribuidores por zona
              </Typography>
            </Box>

            <Divider sx={{ backgroundColor: 'rgba(255,255,255,0.1)' }} />

            {/* Trust Badge */}
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: 1,
              flex:0.33
            }}>
              <VerifiedIcon sx={{ color: '#FF8C00', fontSize: '1.2rem' }} />
              <Typography sx={{ color: 'white', fontSize: '0.8rem' }}>
                Vendedores verificados
              </Typography>
            </Box>
          </Box>
        </Box>
      {/* Hero Section with Banner and Quick Categories */}
      <Box sx={{ 
        position: 'relative',
        minHeight: { xs: '1000px', md: '1000px' },
        color: '#142c40',
        overflow: 'hidden',
        width: '100vw',
        mb: 4
      }}>
        <Container sx={{
          width: '100%',
        }} display='flex' flexDirection='column' justifyContent='center' alignItems='center'>
          {/* <CategoryBar/> */}
        <CategoriesHomePage 
          popularCategories={popularCategories} 
          loading={categoriesLoading} 
        />
 {/* Featured Products Section */}
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: '#fffbf0',
          borderRadius: '1px',
          p: 1,
          mx: '11.5vw'
        }}>
          <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold', fontSize: '1.2rem' }}>
            Productos Destacados
          </Typography>
          
          <Button 
            endIcon={<ArrowForwardIosIcon />}
            component={Link}
            to="/s/"
            sx={{ color: '#FF6B00' }}
          >
            Ver Todos
          </Button>
        </Box>
        
      {!isLoadingProducts && featuredProducts.length > 0 && (
          <PopularProductsShowcase products={featuredProducts} />
        )}
        </Container>
       
      </Box>
      </Box>

      
    </Box>
  ) : (
    <Box sx={{ 
      backgroundImage: 'linear-gradient(to bottom, #ffb775 20%, transparent)',
      pt:'5%',
      minHeight: '100vh',
      overflow: 'visible'
    }}>
      <Box>
        {/* Main Value Proposition Box */}
        <Box sx={{
          backgroundColor: 'rgba(2, 2, 2, 0.75)',
          mx: '4%',
          mb:1.5,
          borderRadius: '2px',
          p: 3,
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        }}>
          {/* Quick Stats to Build Trust */}
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            mb: 2,
            pb: 2,
            borderBottom: '1px solid rgba(255,255,255,0.1)'
          }}>
            <Box sx={{ textAlign: 'center' }}>
              <Typography sx={{ color: '#FF8C00', fontWeight: 'bold', fontSize: '1.5rem' }}>
                0%
              </Typography>
              <Typography sx={{ color: 'white', fontSize: '0.7rem' }}>
                Sin comisiones
              </Typography>
            </Box>
            <Box sx={{ textAlign: 'center' }}>
              <Typography sx={{ color: '#FF8C00', fontWeight: 'bold', fontSize: '1.5rem' }}>
                24/7
              </Typography>
              <Typography sx={{ color: 'white', fontSize: '0.7rem' }}>
                Exposición
              </Typography>
            </Box>
            <Box sx={{ textAlign: 'center' }}>
              <Typography sx={{ color: '#FF8C00', fontWeight: 'bold', fontSize: '1.5rem' }}>
                +1000
              </Typography>
              <Typography sx={{ color: 'white', fontSize: '0.7rem' }}>
                Visitas
              </Typography>
            </Box>
          </Box>

          {/* Key Benefits List */}
          <Box sx={{ mb: 2 }}>
            <Typography sx={{ 
              color: 'white', 
              fontSize: '1.1rem', 
              fontWeight: '500',
              mb: 2 
            }}>
              ¿Por qué unirte como vendedor mayorista?
            </Typography>
            
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1.5 }}>
              <Box sx={{ 
                bgcolor: '#FF8C00', 
                borderRadius: '50%', 
                p: 0.8,
                display: 'flex',
                alignItems: 'center'
              }}>
                <TrendingUpIcon sx={{ color: 'white', fontSize: '1rem' }} />
              </Box>
              <Typography sx={{ color: 'white', fontSize: '0.9rem' }}>
                Aumentá tus ventas con compradores de todo el país
              </Typography>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1.5 }}>
              <Box sx={{ 
                bgcolor: '#FF8C00', 
                borderRadius: '50%', 
                p: 0.8,
                display: 'flex',
                alignItems: 'center'
              }}>
                <MapIcon sx={{ color: 'white', fontSize: '1rem' }} />
              </Box>
              <Typography sx={{ color: 'white', fontSize: '0.9rem' }}>
                Expandí tu zona de distribución y formá parte del mapa de distribuidores
              </Typography>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Box sx={{ 
                bgcolor: '#FF8C00', 
                borderRadius: '50%', 
                p: 0.8,
                display: 'flex',
                alignItems: 'center'
              }}>
                <LibraryBooksIcon sx={{ color: 'white', fontSize: '1rem' }} />
              </Box>
              <Typography sx={{ color: 'white', fontSize: '0.9rem' }}>
                Publicá tus productos y creá tu catálogo digital
              </Typography>
            </Box>
          </Box>

          {/* CTA Section */}
          <Box sx={{ mt: 3 }}>
            <Button
              fullWidth
              variant="contained"
              component={Link}
              to="/signup-distributor"
              sx={{
                bgcolor: '#FF8C00',
                color: 'white',
                py: 1.5,
                fontSize: '1.1rem',
                fontWeight: '500',
                borderRadius: '4px',
                '&:hover': {
                  bgcolor: '#e67e00'
                }
              }}
            >
              ¡Comenzá gratis ahora!
            </Button>
            <Typography sx={{ 
              color: 'rgba(255,255,255,0.7)', 
              fontSize: '0.8rem', 
              textAlign: 'center',
              mt: 1
            }}>
              Cientos de comercios esperan tus productos
            </Typography>
          </Box>
        </Box>
      </Box>
          <Box
        sx={{
          width: '100%',
          pb: 4
        }}
        >
          <Box sx={{ 
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}>
          <ThemeProvider theme={menuTheme}>
         
          </ThemeProvider>
            {/* <CategoryBar/> */}
          </Box>

      {/* Hero Section with Banner and Quick Categories */}
      <Box sx={{ 
        color: '#142c40',
        width: '100%'
      }}>
        <Container 
          maxWidth="xl" 
          sx={{
            px: 0,
          }}
        >
           <Box sx={{ 
          display: 'flex', 
          justifyContent: 'flex-start',
          alignItems: 'center',
          backgroundColor: '#fffbf0',
          borderRadius: '1px',
          height: '55px',
          p: 1,
          mt:3,
          mx: '6.8vw',
        }}>
          <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold', fontSize: {xs:'1rem', md:'1.5rem'}}}>
            Categorías Destacadas
          </Typography>
        </Box>

        <CategoriesHomePage 
          popularCategories={popularCategories} 
          loading={categoriesLoading} 
        />
        <Divider sx={{backgroundColor:'transparent', borderColor:'transparent', width:'90%', height:'10px'}}/>

        
      {/* Featured Products Section */}
      <Container maxWidth="xl" sx={{ mb: 6 }}>
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: '#fffbf0',
          borderRadius: '1px',
          p: 1,
          mx: '3.25vw'
        }}>
          <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold', fontSize: {xs:'1rem', md:'1.5rem'} }}>
            Productos Destacados
          </Typography>
          <Divider orientation="vertical" flexItem />
          <Button 
            endIcon={<ArrowForwardIosIcon />}
            component={Link}
            to="/s"
            sx={{ color: '#FF6B00' }}
          >
            Ver Todos
          </Button>
        </Box>
        {!isLoadingProducts && featuredProducts.length > 0 && (
          <PopularProductsShowcase products={featuredProducts} />
        )}
      </Container>
        </Container>
        
      </Box>
      </Box>

      {/* Benefits Section
      <Container maxWidth="xl" sx={{ mt: { xs: -2, md: -5 }, mb: 6 }}>
        <Grid container spacing={2}>
          {benefits.map((benefit, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card sx={{ 
                height: '100%',
                boxShadow: 3,
                '&:hover': { transform: 'translateY(-5px)', transition: 'transform 0.3s' }
              }}>
                <CardContent sx={{ textAlign: 'center', p: 3 }}>
                  <Box sx={{ color: '#FF6B00', mb: 2 }}>
                    {benefit.icon}
                  </Box>
                  <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold' }}>
                    {benefit.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {benefit.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container> */}

    </Box>
  );
};

export default HomePage; 